export const REQUESTABLE_ROLE_IDS = ['student', 'trainer', 'staff', 'recruiter'];

export const REQUESTABLE_ROLE_LABELS = {
  student: 'Student',
  trainer: 'Faculty / Trainer',
  staff: 'Staff',
  recruiter: 'Recruiter',
};

export function labelForRequestedRole(role) {
  return REQUESTABLE_ROLE_LABELS[role] || role || '';
}
